<template>
  <SingleColumn>
    <template #header>
      <h1 class="text-3xl font-bold text-white">
        Coworker*innen
      </h1>
    </template>
    <template #content>
      <section v-if="empty">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-4 py-5 sm:px-6">
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Du hast noch keine Coworker*innen auf St. Audio.
            </p>
          </div>
        </div>
      </section>
      <section v-else="empty">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="border-t border-gray-200">
            <ul role="list" class="divide-y divide-gray-200">
              <li v-for="coworker in results" :key="coworker.id">
                <router-link :to="{name: 'profile', params: {id: coworker.id}}" class="block hover:bg-gray-50">
                  <div class="flex items-center px-4 py-4 sm:px-6">
                    <div class="min-w-0 flex-1 flex items-center">
                      <div v-if="coworker.image" class="relative">
                        <img class="h-32 w-32 rounded-md" :src="coworker.image.image_uri" :alt="coworker.name" />
                      </div>
                      <div v-else="coworker.image" class="relative">
                        <ProfileIconSvg class="h-32 w-32 rounded-md bg-gray-100" />
                      </div>
                      <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-2">
                        <div>
                          <h2 v-if="coworker.name" class="text-xl font-medium text-teal-600 truncate">
                            {{ coworker.name }}
                          </h2>
                          <h2 v-else="coworker.name" class="text-xl font-medium text-teal-600 truncate">
                            Anonymer User
                          </h2>
                          <p class="mt-2 flex items-center text-sm text-gray-500">
                            {{ coworker.email }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </template>
  </SingleColumn>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useFetchResources } from '@/client/actions';

const props = defineProps({podcast: Object});
const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/coworkers');
const action = useFetchResources(target);

const { results, fetch, empty } = action;

const watcher = watch(target, (v, _) => fetch());
const mounted = onMounted(() => fetch());
</script>
